import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { WarningTwoTone } from '@ant-design/icons';
import { colors } from '../../../GlobalColors';

const NoData = () => {
  return (
    <>
      <WarningTwoTone twoToneColor={colors.teal} />
      <h1>No Data Found</h1>
      <Link to={'/video/annotate'}>
        <Button style={{ color: colors.teal, borderColor: colors.teal }}>
          Go Back
        </Button>
      </Link>
    </>
  );
};

export default NoData;
